import { Col, Row } from 'reactstrap';
import { useFormState } from 'utils/hooks';

import TextArea from 'common/components/form/inputs/Textarea';
import Input from 'common/components/form/inputs/Input';

const AgentType = ({ formState }) => {
  const { fields, changeField } = useFormState(formState);

  return (
    <div>
      <Row className="no-gutters">
        <Col>
          <Input label="Name" onChange={changeField('name')} {...fields.name} />
        </Col>
      </Row>
      <Row className="no-gutters">
        <Col>
          <TextArea
            minlength="5"
            label="Details"
            className="details-textarea"
            onChange={changeField('details')}
            {...fields.details}
          />
        </Col>
      </Row>
    </div>
  );
};

export default AgentType;
